import type { ReactElement } from 'react';
import { Separator, type SeparatorProps } from 'react-aria-components';
import cx from 'clsx';
import styles from './dialog-divider.module.css';

export type DialogDividerProps = SeparatorProps;

export function DialogDivider({ className, ...props }: DialogDividerProps): ReactElement {
  return <Separator className={cx(styles.separator, className)} {...props} />;
}
